var map = {
	"./mileiq-banner.jpg": 1226,
	"./mileiq-taxfyle.png": 1227
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1597;


//////////////////
// WEBPACK FOOTER
// ./src/client/screens/Sweepstakes/img ^\.\/.*$
// module id = 1597
// module chunks = 0